// Map of GPT button IDs to their corresponding hidden input IDs
const DESCRIPTION_INPUT_MAP = {
  "#generateDescriptionBlog": "post-content-input",
  "#generateDescriptionListings": "listing-description-input",
  "#generateDescriptionTribes": "tribe-description-input",
};

function getDescriptionInput(btnId) {
  const inputId = DESCRIPTION_INPUT_MAP[btnId];
  return inputId ? document.getElementById(inputId) : null;
}

function getDescriptionHTML(btnId) {
  const input = getDescriptionInput(btnId);
  return input ? input.value : "";
}

function setDescriptionHTML(btnId, html) {
  const input = getDescriptionInput(btnId);
  if (!input) return;

  // Update the hidden input value
  input.value = html;

  // Find the Tiptap editor container associated with this input
  const editorEl = document.querySelector(
    `[data-tiptap-editor][data-input-id="${input.id}"]`
  );
  if (editorEl) {
    // Dispatch a custom event so tiptap_mount can refresh the editor content
    editorEl.dispatchEvent(
      new CustomEvent("tiptap:setContent", { detail: { html } })
    );
  }
}

const GPT_PAGES_DATA = [
  {
    success: function (response) {
      setAjaxLoading(false);
      isFetchingData = false;
      setDescriptionHTML(
        "#generateDescriptionBlog",
        response.choices[0]["message"]["content"]
      );
    },
    error: function (response) {
      swal({
        title: "Whoops!",
        text: "Something went wrong, please try again later.",
      });
      isFetchingData = false;
      setAjaxLoading(false);
    },
    getData: function () {
      const id = $("#generateDescriptionBlog").data("id");
      const postDescription = getDescriptionHTML("#generateDescriptionBlog");
      return { id: id, description: postDescription, model: "Post" };
    },
    btnId: "#generateDescriptionBlog",
  },
  {
    success: function (response) {
      isFetchingData = false;
      setAjaxLoading(false);
      setDescriptionHTML(
        "#generateDescriptionListings",
        response.choices[0]["message"]["content"]
      );
    },
    error: function (response) {
      swal({
        title: "Whoops!",
        text: "Something went wrong, please try again later.",
      });
      isFetchingData = false;
      setAjaxLoading(false);
    },
    getData: function () {
      const id = $("#generateDescriptionListings").data("id");
      const tribeDescription = getDescriptionHTML(
        "#generateDescriptionListings"
      );
      return {
        id: id,
        tribeDescription: tribeDescription,
        model: "Listing",
      };
    },
    btnId: "#generateDescriptionListings",
  },
  {
    success: function (response) {
      isFetchingData = false;
      setAjaxLoading(false);
      setDescriptionHTML(
        "#generateDescriptionTribes",
        response.choices[0]["message"]["content"]
      );
    },
    error: function (response) {
      isFetchingData = false;
      swal({
        title: "Whoops!",
        text: "Something went wrong, please reload the page and try again.",
      });
      setAjaxLoading(false);
    },
    getData: function () {
      const id = $("#generateDescriptionTribes").data("id");
      const description = getDescriptionHTML("#generateDescriptionTribes");
      return { id: id, description: description, model: "Tribe" };
    },
    btnId: "#generateDescriptionTribes",
  },
];

let isFetchingData = false;

function fetchGptData(success, error, getData, btnId) {
  const fetchData = function () {
    return $.ajax({
      method: "POST",
      url: "/api/gpt",
      data: getData(),
      success: success,
      error: error,
    });
  };
  $(btnId).on("click", function (e) {
    e.preventDefault();
    setAjaxLoading(true);
    fetchData();
  });
}

document.addEventListener("turbolinks:load", function () {
  const buttonsIds = GPT_PAGES_DATA.map(function (data) {
    return data.btnId;
  });
  const hasButtonPresent = buttonsIds.filter(function (btn) {
    return !!$(btn).length;
  });
  if (hasButtonPresent.length) {
    GPT_PAGES_DATA.map(function (data) {
      return fetchGptData(data.success, data.error, data.getData, data.btnId);
    });
  }
});

function setAjaxLoading(show) {
  const loadingImg = document.getElementById("description-ajax-loading");
  if (loadingImg) {
    loadingImg.classList.toggle("hidden", !show);
  }
}
